import { Component, inject } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { MatIcon } from '@angular/material/icon';
import { ButtonComponent, DialogOrBottomSheetRef } from '@letly/ui-common';
import { getPlatformChecks } from '../../core/utils/platform-utils';

@Component({
  selector: 'app-pwa-install',
  standalone: true,
  imports: [
    MatIcon,
    ButtonComponent
  ],
  template: `
    <div class="pwa-install">
      <div class="pwa-install__header">
        <img src="/images/letly-logo.svg" alt="Letly" class="pwa-install__logo" />
        <p class="pwa-install__subtitle" i18n="@@ui-common.pwa-install.subtitle">Install Letly for the best experience</p>
      </div>

      @if (isIos) {
        <ol class="pwa-install__steps">
          <li i18n="@@ui-common.pwa-install.ios.step1">
            Tap the <strong>Share</strong> button
            <mat-icon>ios_share</mat-icon>
          </li>
          <li i18n="@@ui-common.pwa-install.ios.step2">Scroll down and tap <strong>Add to Home Screen</strong></li>
          <li i18n="@@ui-common.pwa-install.ios.step3">Tap <strong>Add</strong> to confirm</li>
        </ol>
        <letly-button variant="ghost" i18n-label="@@ui-common.pwa-install.ios.dismiss.label" label="Maybe later" (click)="dismiss()"></letly-button>
      } @else {
        <div class="pwa-install__actions">
          <letly-button variant="primary" i18n-label="@@ui-common.pwa-install.install.label" label="Install" (click)="install()"></letly-button>
          <letly-button variant="ghost" i18n-label="@@ui-common.pwa-install.dismiss.label" label="Maybe later" (click)="dismiss()"></letly-button>
        </div>
      }
    </div>
  `,
  styleUrl: './pwa-install.scss'
})
export class PwaInstallComponent {
  private readonly doc = inject(DOCUMENT);
  readonly isIos = getPlatformChecks(this.doc).isIos;
  private ref = inject<DialogOrBottomSheetRef<PwaInstallComponent>>(DialogOrBottomSheetRef, { optional: true });

  install(): void {
    this.ref?.close('install');
  }

  dismiss(): void {
    this.ref?.close('dismiss');
  }
}
